"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamCapacity = void 0;
class TeamCapacity {
    constructor(year, month, engineer, teamId, region, periods, timeOff) {
        this.year = year;
        this.month = month;
        this.engineer = engineer;
        this.teamId = teamId;
        this.region = region;
        this.periods = periods;
        this.timeOff = timeOff;
    }
    getWeekdays() {
        return this.periods.reduce((total, period) => {
            return total + period.getWeekdays();
        }, 0);
    }
    getWeekdaysHours() {
        return (((this.getWeekdays() || 0) * 8 * this.getAverageCapacityPercent()) / 100);
    }
    getHolidays() {
        return this.periods.reduce((total, period) => {
            return total + period.getHolidays();
        }, 0);
    }
    getHolidaysHours() {
        return (((this.getHolidays() || 0) * 8 * this.getAverageCapacityPercent()) / 100);
    }
    getWorkingDays() {
        return this.periods.reduce((total, period) => {
            return total + period.getWorkingDays();
        }, 0);
    }
    getAverageCapacityPercent() {
        const weighetTotal = this.periods
            .map((period) => period.percent * period.getWorkingDays())
            .reduce((total, weighted) => total + weighted, 0);
        const percent = weighetTotal / this.getWorkingDays();
        return isNaN(percent) ? 0 : percent;
    }
    getTimeOffHours() {
        return ((this.timeOff || 0) * 8 * this.getAverageCapacityPercent()) / 100;
    }
    getGrossUtilizationHours() {
        return this.periods.reduce((total, period) => {
            return total + period.getCapacityHours();
        }, 0);
    }
    getUtilizationHours() {
        const hours = this.getGrossUtilizationHours();
        return Math.max(hours - this.getTimeOffHours(), 0);
    }
    getNonWorkingHoursPercent() {
        return Math.round(((this.getHolidays() + this.timeOff) / this.getWorkingDays()) * 100);
    }
    getGrossUtilizationHours1850() {
        return this.periods.reduce((total, period) => {
            return total + period.getCapacityHours1850();
        }, 0);
    }
    getUtilizationHours1850() {
        return this.getGrossUtilizationHours1850();
    }
}
exports.TeamCapacity = TeamCapacity;
//# sourceMappingURL=TeamCapacity.js.map